
import React from 'react';

function Logo() {
  return (
    <div className="is-flex is-align-items-center">
      <img src="fulllogot.png"/>
    </div>
  );
}

export default Logo;
